export default "__VITE_ASSET__B7lX1z_b__"